import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface GenSingleImageCtaTextModel extends BaseModel {
  variables?: { [key: string]: string } | GenSingleImageCtaTextVariables;
}

export interface GenSingleImageCtaTextVariables {
  Text: string;
}

export class GenSingleImageCtaTextInitVariables implements GenSingleImageCtaTextVariables {
  Text = '';
}

export class GenSingleImageCtaTextInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new GenSingleImageCtaTextInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
